document.addEventListener("DOMContentLoaded", () => {
  // Réinitialiser currentTab à 1 lorsque index.html est chargé
  localStorage.setItem("currentTab", 1);

  // Votre code pour les vignettes et modules, etc.
  const previews = document.querySelectorAll(".projects-module"); // Tous les modules de projet
  const previewEx = document.querySelectorAll(".projects-websites"); // Vignettes spécifiques

  // Lorsqu'on clique sur une vignette .projects-websites, on enregistre l'ID de l'onglet et redirige vers la page 2
  previewEx.forEach((preview) => {
    preview.addEventListener("click", () => {
      const tabId = preview.getAttribute("data-tab");
      localStorage.setItem("currentTab", tabId);
      window.location.href = "projects-page.html"; // Redirection vers la page 2
    });
  });

  // Lorsqu'on clique sur n'importe quel module de projet, on enregistre l'ID de l'onglet et redirige vers la page 2
  previews.forEach((preview) => {
    preview.addEventListener("click", () => {
      const tabId = preview.getAttribute("data-tab");
      localStorage.setItem("currentTab", tabId);
      window.location.href = "projects-page.html"; // Redirection vers la page 2
    });
  });
});
